import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import cx from "classnames";
import { createBrowserHistory } from "history";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

// material-ui icons
import Menu from "@material-ui/icons/Menu";
import MoreVert from "@material-ui/icons/MoreVert";
import ViewList from "@material-ui/icons/ViewList";
import ArrowBack from "@material-ui/icons/ArrowBack";

// core components
import HeaderLinks from "./HeaderLinks";
import Button from "components/CustomButtons/Button.jsx";
import SearchBar from "components/Search/Search.jsx";
import orb from "assets/img/logos/haney-icon.png";
import Notifications from "../Notifications";
import ProfilePopup from "components/Header/ProfilePopup.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import headerStyle from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";

function Header({ ...props }) {
  // console.log(props);
  function makeBrand() {
    var name;
    props.routes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      }
      if (prop.path === props.location.pathname) {
        name = prop.name;
      }
      return null;
    });
    if (name) {
      return name;
    } else {
      return "CargoRx";
    }
  }
  const { classes, color, rtlActive } = props;
  const appBarClasses = cx({
    [" " + classes[color]]: color,
  });
  const sidebarMinimize =
    classes.sidebarMinimize +
    " " +
    cx({
      [classes.sidebarMinimizeRTL]: rtlActive,
    });
  const hist = createBrowserHistory();
// console.log(props.location.pathname)
  return (
    <AppBar position="fixed" className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden smDown>
          <div
            style={{
              width: "100%",
              paddingLeft: props.miniActive ? "80px" : "260px",
            }}
          >
            <div className={sidebarMinimize}>
              {props.miniActive ? (
                // <Button
                //   justIcon
                //   round
                //   color="primary"
                  
                // >
                ((props.location.pathname == "/orders") || (props.location.pathname == "/trips") || (props.location.pathname == "/dashboard"))  ? <Menu onClick={props.sidebarMinimize} style={{marginTop: "20px"}} className={classes.sidebarMiniIcon} /> : <ArrowBack onClick={hist.goBack} style={{ color: "#000", fontSize: "1rem", marginTop: "20px" }} />
                // </Button>
              ) : (
                // <Button
                //   justIcon
                //   round
                //   color="primary"
                //   onClick={props.sidebarMinimize}
                // >
                 <MoreVert  onClick={props.sidebarMinimize} style={{marginTop: "20px"}}  className={classes.sidebarMiniIcon} />
                // </Button>
                
              )}
            </div>
            <div style={{float: "left", paddingLeft: "20px"}}>
              <div href="#" className={classes.title} color="transparent">
                {makeBrand()}
              </div>
            </div>
            <div style={{ float: "right", margin: "0px 10px" }}>
              <HeaderLinks rtlActive={rtlActive} />
            </div>
            <div style={{ width: "50%", float: "right" }}>
              <SearchBar />
            </div>
          </div>
        </Hidden>
        <Hidden mdUp>
          {props.AuthBool ? (
            <div style={{ width: "100%" }}>
              <Button
                className={classes.appResponsive}
                color="transparent"
                justIcon
                aria-label="open drawer"
                onClick={props.handleDrawerToggle}
                style={{
                  float: "left",
                  width: "20px",
                  minWidth: "20px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <Menu style={{ width: "20px", height: "20px" }} />
              </Button>
              <Button
            className={classes.appResponsive}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={hist.goBack}
          >

            <ArrowBack style={{ color: "#000" }} />
          </Button>
              <Link to={"/dashboard"}>
                <img
                  style={{ float: "left", marginTop: "8px" }}
                  className={classes.orb}
                  src={orb}
                  alt="orb"
                />
              </Link>
              <div style={{ float: "right" }}>
                <ProfilePopup />
              </div>
              <div style={{ marginTop: "1px", float: "right" }}>
                <Notifications />
              </div>
              <SearchBar />
            </div>
          ) : null}
        </Hidden>
        
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
};

export default withStyles(headerStyle)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx